@if (comentarios().length > 0) {
  <select class="form-select rounded-3 text-content-tertiary w-50 mx-auto my-2" id="selectOrdenComentarios"
  (change)="ordenarComentarios($event)">
  <option value="ascendente" selected>Ordenar por: Más antiguo</option>
  <option value="descendente">Ordenar por: Más reciente</option>
</select>

<div class="accordion-container">
  <div ngbAccordion [closeOthers]="true">
    @for (comentario of comentarios(); track comentario.id) {
    <div ngbAccordionItem [collapsed]="$index != 0">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="fw-semibold text-content-secondary bg-surface-secondary"
          (click)="comentario.tipoUsuario != this.tipoPersona ? marcarComentarioLeido(comentario, this.apiUrl): ''">
          {{ comentario.fechaAlta | date: 'longDate': 'es-MX' }}
          {{ comentario.tipoUsuario === 'interno' ? '- Comentario de Analista' : (comentario.tipoUsuario === 'externo' ?
          '- Comentario de Arrendador' : '') }}
          <div *ngIf="comentario.leido === false && comentario.tipoUsuario != this.tipoPersona"
            class="ms-2 spinner-grow spinner-grow-sm text-oxxo-red" role="status"></div>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody class="small text-break">
          <ng-template>
            {{ comentario.mensaje }}
          </ng-template>
        </div>
      </div>
    </div>
    }
  </div>
</div>
} @else {
  <p class="text-center">Esta sección se encuentra actualmente vacía.</p>
}

<div class="d-flex justify-content-center">
  <button type="button" *ngIf="!mostrarCajaComentario" (click)="mostrarCajaComentario = !mostrarCajaComentario"
    class="btn rounded-5 fw-semibold mt-4 text-white"
    [ngClass]="tipoPersona === 'externo'? 'btn-oxxo-red': 'btn-oxxo-yellow'">
    <svg *ngIf="tipoPersona === 'externo'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
      fill="none">
      <g clip-path="url(#clip0_649_2112)">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8.57143 7.32994C8.57143 6.8791 8.93691 6.51362 9.38776 6.51362H19.1837C19.6345 6.51362 20 6.8791 20 7.32994V14.6769C20 15.1277 19.6345 15.4932 19.1837 15.4932H17.551V18.3504C17.551 18.6805 17.3521 18.9782 17.0471 19.1045C16.742 19.2309 16.3909 19.161 16.1575 18.9276L12.7231 15.4932H9.38776C8.93691 15.4932 8.57143 15.1277 8.57143 14.6769V7.32994ZM10.2041 8.14627V13.8606H13.0612C13.2777 13.8606 13.4854 13.9466 13.6385 14.0997L15.9184 16.3796V14.6769C15.9184 14.226 16.2838 13.8606 16.7347 13.8606H18.3673V8.14627H10.2041Z"
          fill="white" />
        <path
          d="M15.102 4.88096V2.87416C15.102 2.33296 14.8871 1.81385 14.5043 1.43109C14.1216 1.04833 13.6024 0.833344 13.0612 0.833344H2.04082C1.49957 0.833344 0.980465 1.04836 0.597736 1.43109C0.215006 1.81382 0 2.33292 0 2.87416V9.77892C0 10.3201 0.214989 10.8393 0.597747 11.222C0.980509 11.6048 1.49962 11.8197 2.04082 11.8197H3.67347V14.6769C3.67347 14.9861 3.84817 15.2687 4.12472 15.407C4.40128 15.5453 4.73223 15.5155 4.97959 15.3299L7.42857 13.4932C7.78925 13.2227 7.86234 12.711 7.59184 12.3503C7.32133 11.9897 6.80966 11.9166 6.44898 12.1871L5.30612 13.0442V11.0034C5.30612 10.5526 4.94064 10.1871 4.4898 10.1871H2.04082C1.93251 10.1871 1.8287 10.1441 1.7522 10.0676C1.67568 9.99105 1.63265 9.88719 1.63265 9.77892V2.87416C1.63265 2.76591 1.67567 2.66208 1.75221 2.58554C1.82874 2.509 1.93256 2.466 2.04082 2.466H13.0612C13.1695 2.466 13.2734 2.50903 13.3499 2.58554C13.4264 2.66205 13.4694 2.76586 13.4694 2.87416V4.88096C13.4694 5.33181 13.8349 5.69729 14.2857 5.69729C14.7366 5.69729 15.102 5.33181 15.102 4.88096Z"
          fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_649_2112">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg *ngIf="tipoPersona === 'interno'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
      fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M14.9571 1.67402C14.3879 1.71312 13.817 1.92051 13.3425 2.26058C13.2584 2.32091 13.1625 2.39847 13.0705 2.48079C13.0265 2.52013 10.7461 4.79729 8.00295 7.54114C4.53463 11.0104 3.00692 12.5427 2.98751 12.5719C2.93425 12.652 2.90926 12.7154 2.8702 12.87C2.84981 12.9506 2.57389 14.0276 2.25704 15.2633C1.94019 16.499 1.67747 17.5325 1.67321 17.56C1.66222 17.6311 1.66925 17.7637 1.68735 17.8266C1.70542 17.8894 1.75017 17.9853 1.7873 18.0408C1.82997 18.1045 1.92831 18.1977 1.99313 18.2358C2.13209 18.3175 2.30393 18.3497 2.45794 18.323C2.53818 18.3091 7.23729 17.1036 7.29299 17.0826C7.34316 17.0637 7.39519 17.0357 7.44381 17.0014C7.48459 16.9727 17.4181 7.0436 17.5231 6.92663C17.8197 6.59623 18.0364 6.22203 18.177 5.79725C18.4055 5.10725 18.3834 4.34266 18.1154 3.65996C17.7292 2.67607 16.8739 1.95296 15.8371 1.73377C15.5654 1.67632 15.2427 1.65441 14.9571 1.67402ZM15.0771 3.03058C14.8233 3.04994 14.618 3.10565 14.3905 3.21694C14.2901 3.26604 14.1138 3.37342 14.1138 3.38548C14.1138 3.39193 16.6128 5.89001 16.6156 5.88635C16.6169 5.88467 16.6271 5.87129 16.6383 5.85663C16.678 5.80491 16.75 5.68229 16.791 5.59663C16.882 5.40639 16.9349 5.2263 16.9614 5.01663C16.9753 4.90659 16.9718 4.67411 16.9546 4.56092C16.8422 3.82356 16.3173 3.24972 15.5963 3.07597C15.4831 3.04867 15.3599 3.0334 15.2305 3.03062C15.1645 3.0292 15.0955 3.02918 15.0771 3.03058ZM12.9021 4.56831L12.6738 4.79667L13.9388 6.06166L15.2039 7.32665L15.4338 7.09663L15.6638 6.8666L14.4005 5.60328C13.7056 4.90845 13.1356 4.33996 13.1338 4.33996C13.1319 4.33996 13.0277 4.44272 12.9021 4.56831ZM8.11048 9.35996L4.51715 12.9533L5.78215 14.2183L7.04715 15.4833L10.6421 11.8883L14.2371 8.2933L12.9738 7.02996C12.279 6.33513 11.709 5.76663 11.7072 5.76663C11.7053 5.76663 10.0868 7.38363 8.11048 9.35996ZM3.89505 14.361C3.88363 14.4062 3.74382 14.9517 3.58435 15.573C3.42488 16.1944 3.29513 16.7035 3.29603 16.7044C3.29741 16.7058 5.69045 16.0933 5.71277 16.0859C5.71702 16.0844 5.31444 15.6772 4.81815 15.181L3.9158 14.2786L3.89505 14.361Z"
        fill="white" />
    </svg>
    Agregar nuevo comentario
  </button>
</div>

<form *ngIf="mostrarCajaComentario" id="form-borrar-inmueble" [formGroup]="comentarioFormulario" (ngSubmit)="onSubmit()"
  class="mt-4">

  <textarea appPreventNewline
    class="w-100 form-control rounded-3"
    form="form-borrar-inmueble"
    maxlength="500"
    name="comentario"
    id="textarea-comentario"
    formControlName="comentario"
    placeholder="Comentario..."
  ></textarea>
  <label for="textarea-comentario" class="visually-hidden">Escribir comentario</label>

  <div class="row justify-content-between mb-4 px-2">
    <div class="col-auto">
      <small class="text-content-tertiary">Caracteres</small>
    </div>
    <div class="col-auto">
      <small [ngClass]="[
              longitudComentario < 250 ? 'text-content-tertiary' : '',
              longitudComentario >= 250 &&
              longitudComentario < 500 ? 'text-oxxo-yellow' : '',
              longitudComentario >= 500 ? 'text-oxxo-red' : '',
            ]">
        {{ longitudComentario }}/500
      </small>
    </div>
  </div>

  <div class="row justify-content-center gap-2">
    <div class="col-auto">
      <button type="submit" class="btn btn-content-secondary rounded-5 px-4" [disabled]="!comentarioFormulario.valid">
        Guardar
      </button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-content-inverse-tertiary rounded-5 px-4 text-white"
        (click)="mostrarCajaComentario = !mostrarCajaComentario">
        Cancelar
      </button>
    </div>
  </div>
</form>
